let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dTt25")).then(() => parcelRequire('8KVwU'));